// components/ContactUs.js
import React from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const contactInfo = [
    {
      id: 1,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      label: 'Our Location',
      value: 'No.32, Masakalipalayam Road,Lakshmipuram 4th Street,Peelamedu,Coimbatore,Tamil Nadu',
    },
    {
      id: 3,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      ),
      label: 'Email Us',
      value: 'support@queeslot.com',
      // Opens Gmail compose in the browser
      href: 'https://mail.google.com/mail/?view=cm&fs=1&to=support@queeslot.com&su=Booking%20Enquiry&body=Hello%20QSlot%20Team,',
    },
  ];

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        {/* Section Header */}
        <div className="contact-header">
          <span className="contact-tag">CONTACT US</span>
          <h2 className="contact-title">
            Get in Touch <span className="contact-title-highlight">With Us</span>
          </h2>
          <p className="contact-subtitle">
            Have a question or need help booking? Reach out — we're always here
            to help you.
          </p>
        </div>

        <div className="contact-grid">
          {/* Left Side: Image Only */}
          <div className="contact-left">
            <div className="contact-image-wrapper">
              <img
                src="/img/contact-us.png"
                alt="Contact QSlot"
                className="contact-image"
              />
              <div className="contact-image-overlay"></div>
            </div>
          </div>

          {/* Right Side: Detailed Contact Panel */}
          <div className="contact-right">
            <div className="contact-panel">
              <div className="contact-panel-header">
                <span className="contact-panel-tag">REACH US</span>
                <h3 className="contact-panel-title">
                  We'd Love to <span className="contact-panel-highlight">Hear From You</span>
                </h3>
                <p className="contact-panel-subtitle">
                  Whether you need a booking, have a question, or want to partner
                  with us — our team is ready to help.
                </p>
              </div>

              <div className="contact-panel-list">
                {contactInfo.map((info) => (
                  <div key={info.id} className="contact-panel-item">
                    <div className="contact-panel-icon-wrapper">
                      <span className="contact-panel-icon">{info.icon}</span>
                    </div>
                    <div className="contact-panel-content">
                      <span className="contact-panel-label">{info.label}</span>

                      {info.href ? (
                        <a
                          href={info.href}
                          target={info.href.startsWith('http') ? '_blank' : undefined}
                          rel={info.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="contact-panel-value contact-panel-value-link"
                        >
                          {info.value}
                        </a>
                      ) : (
                        <span className="contact-panel-value">{info.value}</span>
                      )}

                      {info.subValue && (
                        <span className="contact-panel-subvalue">{info.subValue}</span>
                      )}

                      {info.href && info.linkText && (
                        <a
                          href={info.href}
                          target={info.href.startsWith('http') ? '_blank' : undefined}
                          rel={info.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="contact-panel-link"
                        >
                          {info.linkText}
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Row */}
              <div className="contact-panel-social">
                <span className="contact-panel-social-label">Follow Us</span>
                <div className="contact-panel-social-icons">
                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/share/18jkB6Fmqs/?mibextid=wwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="social-icon"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a
                    href="https://www.instagram.com/qslot_?igsh=MW8wY2YxeGQ1eGo1Yw"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="social-icon"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                    </svg>
                  </a>

                  {/* YouTube */}
                  <a
                    href="https://www.youtube.com/@QSLOT-OnlineBookingApp/videos"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                    className="social-icon"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;